module.exports = __webpack_public_path__ + "static/media/dreamBox.e18685b3.jpg";